import { mapState } from 'vuex'
import { ToolsClass } from '@/base/class/tools.class'

export default {
  computed: {
    ...mapState({
      /**
       * Dane konfiguracyjne dla ThreatMetrix pobrane ze stanu płatności.
       * @returns {Object|boolean} Obiekt z polami orgId i sessionId lub false, jeśli brak danych.
       */
      threatMetrix: state => state.payment.paymentData?.threatMetrix || false
    }),
    /**
     * Sprawdza, czy profilowanie ThreatMetrix powinno zostać uruchomione.
     * @returns {boolean}
     */
    isThreatMetrixEnabled: function () {
      return !!this.threatMetrix
    }
  },
  watch: {
    /**
     * Reaguje na pojawienie się danych ThreatMetrix w stanie aplikacji.
     * @param {Object|boolean} value Nowe dane konfiguracyjne.
     * @param {Object|boolean} oldValue Poprzednie dane konfiguracyjne.
     */
    threatMetrix: {
      handler: function (value, oldValue) {
        if (this.isThreatMetrixEnabled && JSON.stringify(value) !== JSON.stringify(oldValue)) {
          this.loadThreatMetrixScript()
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Inicjuje ładowanie zewnętrznego skryptu profilującego ThreatMetrix.
     * Buduje URL na podstawie orgId i sessionId i dodaje go do nagłówka dokumentu.
     */
    loadThreatMetrixScript () {
      if (this.threatMetrix.orgId == null || this.threatMetrix.sessionId == null) {
        return
      }
      const orgId = String(this.threatMetrix.orgId)
      const sessionId = String(this.threatMetrix.sessionId)
      if (!orgId.length || !sessionId.length) {
        return
      }
      const url = `https://h.online-metrix.net/fp/tags.js?org_id=${encodeURIComponent(orgId)}&session_id=${encodeURIComponent(sessionId)}`
      ToolsClass.loadExternalScriptsToHeader(url)
    }
  }
}
